import { decryptOpenSslAes, encryptOpenSslAes } from './aesOpenSSL';

function secretKey(): string {
  return process.env.NEXT_PUBLIC_CRYPTO_SECRET_KEY || '';
}

export const encryptAES = (value?: string | null): string => {
  if (value === undefined || value === null) return '';
  return encryptOpenSslAes(String(value), secretKey());
};

export const decryptAES = (value?: string | null): string => {
  if (!value) return '';
  try {
    return decryptOpenSslAes(value, secretKey());
  } catch {
    return '';
  }
};
